import { render, staticRenderFns } from "./autoCall.vue?vue&type=template&id=5ac419de&scoped=true&"
import script from "./autoCall.vue?vue&type=script&lang=ts&"
export * from "./autoCall.vue?vue&type=script&lang=ts&"
import style0 from "./autoCall.vue?vue&type=style&index=0&id=5ac419de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac419de",
  null
  
)

export default component.exports